import produce from 'immer';

const INITIAL_STATE = {
  loading: false,
  data: [],
  page: 1,
  pageSize: 10,
  totalCount: 0,
  totalPages: 0,
  find: null,
  params: {},
};

export default function recalculaTurno(state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case '@recalculaTurno/FIND_DATA':
      case '@recalculaTurno/UPDATE_DATA':
      case '@recalculaTurno/DELETE_DATA':
      case '@recalculaTurno/STORE_DATA':
      case '@recalculaTurno/DATA_IN_REQUEST': {
        draft.loading = true;
        break;
      }

      case '@recalculaTurno/SUCCESS_REMOVE':
      case '@recalculaTurno/FAILED_REQUEST': {
        draft.loading = false;
        break;
      }

      case '@recalculaTurno/SUCCESS_IN_REQUEST': {
        draft.loading = false;
        draft.data = action.payload.data;
        draft.page = action.payload.page;
        draft.pageSize = action.payload.pageSize;
        draft.totalCount = action.payload.totalCount;
        draft.totalPages = action.payload.totalPages;
        draft.find = {};
        break;
      }

      case '@recalculaTurno/SUCCESS_REQUEST': {
        draft.loading = false;
        draft.find = action.payload.data;
        break;
      }

      case '@recalculaTurno/RECORD_FILTERING': {
        draft.loading = true;
        draft.params = { ...draft.params, ...action.payload.params };
        break;
      }

      case '@hooks/RESET': {
        draft.data = [];
        draft.page = 1;
        draft.pageSize = 10;
        draft.totalCount = 0;
        draft.totalPages = 0;
        draft.find = null;
        draft.params = {};
        break;
      }

      default:
    }
  });
}
